"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CiamActiveDirectory = void 0;
const react_1 = __importDefault(require("react"));
class CiamActiveDirectory extends react_1.default.Component {
  constructor(props) {
    super(props);
    this.saveData = false;
    this.registerLite = () => {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-LiteRegistration",
        startScreen: "gigya-subscribe-with-email-screen"
      });
    };
    this.register = () => {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-RegistrationLogin",
        startScreen: "gigya-register-screen"
      });
    };
    this.login = () => {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-RegistrationLogin",
        sessionExpiration: 0
      });
    };
    this.logout = () => {
      gigya.accounts.logout();
    };
    this.editProfile = () => {
      gigya.accounts.showScreenSet({
        screenSet: "ColsubB2C-ProfileUpdate",
        startScreen: "gigya-update-profile-screen"
      });
    };
    this.onLogin = resp => {
      console.log("Pasó una vez");
      const dataJson = JSON.stringify(resp);
      if (sessionStorage.getItem("X-GigyaData-X") === "true") {
        localStorage.setItem("X-GigyaOnUserData-X", dataJson);
      }
      sessionStorage.setItem("X-GigyaCookies-X", "True");
      const {
        loginCallBack
      } = this.props;
      if (loginCallBack) {
        loginCallBack(resp).then(() => {
          setTimeout(() => {
            window.location.href = sessionStorage.getItem("X-GigyaRedirectUrl-X") + "";
          }, 100);
        });
      } else {
        setTimeout(() => {
          window.location.href = sessionStorage.getItem("X-GigyaRedirectUrl-X") + "";
        }, 100);
      }
    };
    this.onLogout = resp => {
      localStorage.removeItem("X-GigyaOnUserData-X");
      sessionStorage.removeItem("X-GigyaCookies-X");
      window.location.href = sessionStorage.getItem("X-GigyaRedirectUrl-X") + "";
    };
    this.state = {
      authenticated: false,
      contentClassA: "content-default-class",
      btnClassA: "btn-default-class",
      styles: {
        contentdefaultclass: {},
        btndefaultclass: {}
      }
    };
  }
  componentDidMount() {
    const {
      apiKey,
      redirectLogin,
      cdn,
      autoopen
    } = this.props;
    sessionStorage.setItem("X-GigyaRedirectUrl-X", redirectLogin + "");
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "".concat(cdn, "/js/gigya.js?apikey=").concat(apiKey);
    script.async = true;
    script.lang = "javascript";
    document.head.appendChild(script);
    sessionStorage.setItem("X-GigyaData-X", this.saveData + "");
    const isAuthenticated = !!sessionStorage.getItem("X-GigyaCookies-X");
    this.setState({
      authenticated: isAuthenticated
    });
    setTimeout(() => {
      gigya.accounts.addEventHandlers({
        onLogin: this.onLogin,
        onLogout: this.onLogout
      });
    }, 250);
    if (autoopen) {
      const button = document.getElementById("btn-colsub-login");
      if (button) {
        button.setAttribute("disabled", "true");
        setTimeout(() => {
          button.removeAttribute("disabled");
          button.click();
        }, 1000);
      }
    }
  }
  render() {
    const {
      btnRegisterLite,
      btnRegister,
      btnEditProfile,
      contentClass,
      btnClass
    } = this.props;
    const {
      authenticated,
      contentClassA,
      btnClassA,
      styles
    } = this.state;
    const updatedContentClassA = contentClass || contentClassA;
    const updatedBtnClassA = btnClass || btnClassA;
    if (!contentClass) {
      styles.contentdefaultclass = {
        position: "absolute",
        display: "block",
        width: "100% !important",
        height: "40px",
        backgroundColor: "#0067B1",
        margin: "0",
        padding: "0",
        top: "0",
        right: "0",
        left: "0",
        zIndex: 20
      };
    }
    if (!btnClass) {
      styles.btndefaultclass = {
        backgroundColor: "#FFD000",
        border: "none",
        width: "100px",
        height: "35px",
        color: "#0067B1",
        float: "right",
        margin: "2.5px",
        cursor: "pointer",
        fontWeight: "500",
        fontSize: "16px",
        borderRadius: "3px"
      };
    }
    return react_1.default.createElement("div", {
      className: updatedContentClassA,
      style: styles.contentdefaultclass
    }, !authenticated && btnRegisterLite && react_1.default.createElement("button", {
      onClick: this.registerLite,
      id: "btn-colsub-registerLite",
      className: updatedBtnClassA,
      style: styles.btndefaultclass
    }, "Registro lite"), !authenticated && btnRegister && react_1.default.createElement("button", {
      onClick: this.register,
      id: "btn-colsub-register",
      className: updatedBtnClassA,
      style: styles.btndefaultclass
    }, "Registrarse"), !authenticated && react_1.default.createElement("button", {
      onClick: this.login,
      id: "btn-colsub-login",
      className: updatedBtnClassA,
      style: styles.btndefaultclass
    }, "Ingresar"), authenticated && react_1.default.createElement("button", {
      onClick: this.logout,
      id: "btn-colsub-logout",
      className: updatedBtnClassA,
      style: styles.btndefaultclass
    }, "Salir"), authenticated && btnEditProfile && react_1.default.createElement("button", {
      onClick: this.editProfile,
      id: "btn-colsub-edit-profile",
      className: updatedBtnClassA,
      style: styles.btndefaultclass
    }, "Perfil"));
  }
}
exports.CiamActiveDirectory = CiamActiveDirectory;